// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#recruitment-contact-register[data-v-81d95e62]{max-width:700px;margin-left:auto;margin-right:auto}#recruitment-contact-register .done-name[data-v-81d95e62]{height:27px;margin-bottom:4px;font-size:18px;font-weight:700}#recruitment-contact-register .cancel-btn[data-v-81d95e62],#recruitment-contact-register .update-btn[data-v-81d95e62]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
